<template>
  <v-app light id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
       
    >
      <v-container  v-if="member" grid-list-mxs text-xs-center >
        <v-layout  row wrap >
          <v-flex xs12 >
              <div  >
                <v-avatar
                  :tile="false"
                  :size="56"
                  
                >
                  <img v-if="member.profilepic && member.profilepic.fileurl" v-bind:src="member.profilepic.fileurl" alt="avatar">
                  <img v-else-if="user.photoUrl" v-bind:src="user.photoUrl" alt="avatar">
                </v-avatar>
                <h3>{{member.firstname}} {{member.lastname}}</h3>
                <p v-if="memberLine">{{memberLine.lineyear}} - {{memberLine.lineseason}}</p>
                <p v-if="memberLine">{{memberLine.linename}}</p>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile
          v-for="item in menuItemsAccount"
          :key="item.title"
          :to="item.path"
           
          >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>  
      <v-divider></v-divider>

      <v-list>
        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
           
          >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>  

      <v-divider></v-divider>
     <v-subheader class="pa-1" v-if="menuItemsFundraising && menuItemsFundraising.length>0">Fundraising</v-subheader>
      <v-list>
        <v-list-tile
          v-for="itm in menuItemsFundraising"
          :key="itm.title"
          :to="itm.path">
          <v-list-tile-action>
            <v-icon>{{ itm.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ itm.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>  

      <v-divider></v-divider>
     <v-subheader class="pa-1">Shop</v-subheader>
      <v-list>
        <v-list-tile
          v-for="itm in menuItemsStore"
          :key="itm.title"
          :to="itm.path">
          <v-list-tile-action>
            <v-icon>{{ itm.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ itm.title }}</v-list-tile-content>
            <v-list-tile-avatar>
              <v-icon  color="red">fiber_new</v-icon>
            </v-list-tile-avatar>          
        </v-list-tile>
      </v-list>  


      <v-divider></v-divider>
     <v-subheader class="pa-1" v-if="menuItemsPosts && menuItemsPosts.length>0">Member Posts</v-subheader>
      <v-list>
        <v-list-tile
          v-for="itm in menuItemsPosts"
          :key="itm.title"
          :to="itm.path">
          <v-list-tile-action>
            <v-icon>{{ itm.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ itm.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>  

    </v-navigation-drawer>
    <v-toolbar dark color="primary" fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title><router-link to="/" tag="span" style="cursor: pointer">{{ appTitle }} </router-link></v-toolbar-title> 
      <v-spacer></v-spacer> 
      <template v-if="userIsAuthenticated">
        <router-link to="/signout" tag="span" style="cursor: pointer">
          <v-icon>lock</v-icon>
          sign out
        </router-link>
      </template>
      <template v-else>
        <router-link to="/signin" tag="span" style="cursor: pointer">        
          <v-icon>lock_open</v-icon>
          signin
        </router-link>
      </template>
    </v-toolbar>
    <v-content>
      <v-flex xs12 v-if="member && currentToken===null && showNotificationButton===true">
              <v-alert
                :value="member && currentToken===null"
                type="error"
                class="caption"
              >
              <v-layout row wrap>
                <v-flex xs8>
                For the best in-app experience, please enable notifications &nbsp;&nbsp; <v-icon small color="white">fas fa-external-link-alt</v-icon>
                </v-flex>
                <v-flex xs4>
                  <v-btn color="primary" small @click="requestPermission()">enable</v-btn>
                </v-flex>
              </v-layout>
              </v-alert>     
      </v-flex>

      <v-flex xs12 v-if="((fundraiserTechassessmentSubscriptionStatus===undefined || fundraiserTechassessmentSubscriptionStatus===null || fundraiserTechassessmentSubscriptionStatus.isactive===false) && member!==null)">
              <v-alert
                :value="fundraiserTechassessmentSubscriptionStatus===undefined || fundraiserTechassessmentSubscriptionStatus===null || fundraiserTechassessmentSubscriptionStatus.isactive===false"
                type="error"
                class="caption"
              >
              <v-layout row wrap>
                <v-flex xs8>              
                  <router-link to="/techassessment" tag="span" style="cursor: pointer">Make your contribution to the Chapter's Technology Fund &nbsp;&nbsp; <v-icon color="white">far fa-money-bill-alt</v-icon></router-link>
                </v-flex>
                <v-flex xs4>
                  <v-btn :to="{path: '/techassessment'}" color="primary" small >Contribute</v-btn>
                </v-flex>
              </v-layout>
              </v-alert>     
      </v-flex>

  
      <v-flex xs12>
          <v-snackbar
              top
              class="caption"
              multi-line
              v-if="messages && messages.length>0"
              v-model="showNotificationSnackbar"
          >
              {{messages[messages.length-1].notification.title}}: {{text_truncate(messages[messages.length-1].notification.body)}}
              <v-btn
                  color="primary"
                  flat
                  @click="showNotificationSnackbar = false"
              >
                  Close
              </v-btn>                            
          </v-snackbar>
        </v-flex>
      <v-container fluid  pa-0 id="routerview">
        <router-view  :key="$route.fullPath"></router-view>

      </v-container>
    </v-content>

  <v-footer class="pa-3"
  dark
  color="primary"
  
  >
  
  
  <v-icon @click="visitLinkedin">cloud</v-icon>
  
  <v-subheader @click="visitLinkedin" style="padding-left:4px;">Powered by Cephas </v-subheader>
  
  
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>



  </v-app>
</template>


<script>
import firebase from 'firebase'
import LogRocket from 'logrocket';



  export default {
    data: () => ({
      drawer: false,
      appTitle: 'ZZ Ques',
      bottomNav: 'recent',
      notificationsOn: true,
      currentToken: null,
      messages: [],
      showNotificationSnackbar: false
    }),  
    mounted: function (){

      if(window.location.href.indexOf('192.') || window.location.href.indexOf('localhost') ){
        LogRocket.init('htmrw7/zzques_local')
      }else{
        LogRocket.init('htmrw7/zzques-prod')
      }

      var objThemeOpp = {
          primary: "#673AB7",
          secondary: "#673AB7",
          accent: "#FFEA00",
          error: "#f44336",
          warning: "#EF6C00",
          info: "#2196f3",
          success: "#4caf50",
          metatheme: "#371677"

      }
      var objThemeAka = {
          primary: "#F06292",
          secondary: "#D81B60",
          accent: "#AED581",
          error: "#f44336",
          warning: "#FF9800",
          info: "#2196f3",
          success: "#4caf50",
          metatheme: "#7CB342"

      }      

      var myTheme = objThemeOpp

      document.title = this.appTitle
      document.head.querySelector('meta[name=theme-color]').content = myTheme.metatheme     

      var httpequivs = [{equiv: 'Cache-Control',content:'no-cache, no-store, must-revalidate'},
      {equiv: 'Pragma', content:'no-cached'},
      {equiv: 'Expires', content: '0'}]

      httpequivs.forEach(h =>{
         var meta =  document.createElement('meta')
         meta.content = h.content
         meta.httpEquiv = h.equiv
         document.getElementsByTagName('head')[0].appendChild(meta)
      })
      var stagingGoogleSigninClientId = "899290077649-co8c1ulnesraegvsqilr45bur63a0o91.apps.googleusercontent.com"
      var prodGoogleSigninClientId = "951007987182-6krr1rnljq3bbgvfnje2g3p6t99fe86l.apps.googleusercontent.com"
      var googleSigninClientId     
      if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
        googleSigninClientId= stagingGoogleSigninClientId
      }else if(process.env.NODE_ENV==='production'){
        googleSigninClientId= prodGoogleSigninClientId
      }

      
        var meta =  document.createElement('meta')
         meta.content = googleSigninClientId
         meta.name = "google-signin-client_id"
         document.getElementsByTagName('head')[0].appendChild(meta)

      
      this.$vuetify.theme.accent=myTheme.accent
      this.$vuetify.theme.error=myTheme.error
      this.$vuetify.theme.info=myTheme.info
      this.$vuetify.theme.primary=myTheme.primary
      this.$vuetify.theme.secondary=myTheme.secondary
      this.$vuetify.theme.success=myTheme.success
      this.$vuetify.theme.warning=myTheme.warning


      



      


      
    },
    created(){
      
      /*
      console.log("registering service worker from app.vue")
      navigator.serviceWorker.register('./firebase-messaging-sw.js')
        .then((registration) => {
          console.log("registering service worker registration", registration)
          this.$messaging.useServiceWorker(registration)
          console.log("registering service worker asking permission")
          this.$messaging.requestPermission()
            .then(() => {
              console.log("registering service worker got permission, getting token")
              this.$messaging.getToken().then(token => {
                console.log(`The token is ${token}`)
                // Store the token in the firebase db
              })
            })
        }).catch(err => {
          console.log(err)
        })
        */
/*
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        this.$messaging.useServiceWorker(registration);

        // Request permission and get token.....
      });
*/

try{
    if(this.$isMessagingEnabled){
      this.$messaging.onTokenRefresh(()=> {
        this.$messaging.getToken().then(refreshedToken=> {
          console.log('Token refreshed.');
          this.currentToken = refreshedToken
          console.log('onTokenRefresh this.currentToken =' + this.currentToken)
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
          // Display new Instance ID token and clear UI of all previous messages.
          this.resetUI();
        }).catch(function(err) {
          console.log('Unable to retrieve refreshed token ', err);
        });
      });

      this.$messaging.onMessage(payload=> {
        console.log('Message received. ', payload);
        // Update the UI to include the received message.
        this.appendMessage(payload);
      });
    }else{
      console.log("messaging is NOT enabled on this device")
    }

}catch(err){
  console.warn('error with firebase messaging ' + JSON.stringify(err))
  this.$isMessagingEnabled = false
}




    },
    computed:{
      showNotificationButton () {
        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        if(iOS===false){
          console.log('inside showNotificationButton Notification.permission', Notification.permission)
        }
        
        var rtn = true
        try{
          if(iOS===false || this.$route.name==='home' || this.$route.name==='signin' || this.$route.name==='signout' || this.$isMessagingEnabled ===false){
            rtn=false
          }else if (this.currentToken===null && (Notification && Notification.permission === "granted") || (Notification && Notification.permission === "default")) {
            console.log('inside showNotificationButton requestPermission')
            this.requestPermission().then(v=>{
              console.log('requestPermission.then v ' + v)
              rtn=false
            }).catch(err=>{
              console.error(err)
              rtn=true
            })
          }else if(Notification.permission === "denied"){
            console.log('inside showNotificationButton denied')
            rtn = false
          }else{

            console.log('inside showNotificationButton else')
            rtn = true
          }

          return rtn

        }catch(err){
          console.log('error', err)
          return false
        }


      },
      myColor () {
         return this.$store.getters.myColor
      },      
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      user () {
         return this.$store.getters.user
      },
      member () {
         return this.$store.getters.member
      },
      memberLine () {
         return this.$store.getters.memberLine
      },   
      listPostTypes () {
          return this.$store.getters.listPostTypes
      },   
      menuItemsAccount () {
        var mi = []
        mi.push({ title: 'Home', path: '/', icon: 'home' })
        if(this.$store.getters.user){
          mi.push({ title: 'Sign Out', path: '/signin', icon: 'lock_open' })
          if(!this.$store.getters.member){
             mi.push({ title: 'Register', path: '/register', icon: 'perm_identity' })
          }else{
            mi.push({ title: 'Profile', path: '/profile', icon: 'account_box' })
            mi.push({ title: 'Verify Members', path: '/verify', icon: 'verified_user' })
          }
        }else{
          mi.push({ title: 'Sign In', path: '/signin', icon: 'lock_close' })
        }
        
        return mi
      },            
      menuItems () {
        var mi = []
        if(this.$store.getters.user){
          if(this.$store.getters.member){
            mi.push({ title: 'Timeline', path: '/timeline', icon: 'timeline' })
            mi.push({ title: 'Chat', path: '/conversations', icon: 'chat' })
            mi.push({ title: 'Network', path: '/connect', icon: 'language' })            
            mi.push({ title: 'Checkin', path: '/checkin', icon: 'where_to_vote' })
            mi.push({ title: 'Gallery', path: '/gallery', icon: 'add_a_photo' })
          }
        }
        
        return mi
      },
      menuItemsFundraising () {
        var mi = []
        if(this.$store.getters.user){
          if(this.$store.getters.member){
            mi.push({ title: 'Endowment', path: '/endowment', icon: 'school' })
            mi.push({ title: 'Homecoming', path: '/homecoming', icon: 'restaurant' })                        
            mi.push({ title: 'Technology Budget', path: '/techassessment', icon: 'computer' }) 
            
          }
        }
        
        return mi
      },      
      menuItemsPosts () {
        var mi =[];
        if(this.$store.getters.member){          
            var tmpListPostTypes = this.$store.getters.listPostTypes
            var postCats = Object.keys(tmpListPostTypes)
            postCats.forEach(function(c){
                var postCat = c
                var tmpTitle = postCat.substring(0,1).toUpperCase() + postCat.substring(1)
                var tmpIcon =  tmpListPostTypes[postCat].categoryicon
                var tmpPath = '/' + postCat
                mi.push({ title: tmpTitle, path: tmpPath, icon: tmpIcon })
            })
        }
        return mi
      },
      menuItemsStore () {
        var mi =[];
        if(this.$store.getters.user){
          if(this.$store.getters.member){        
            mi.push({ title: 'Buy Merchandise', path: '/store', icon: 'shopping_cart' })
          }
        }
        return mi
      },      
      fundraiserPayments (){
        return this.$store.getters.fundraiserPayments
      },
      fundraiserTechassessmentSubscriptionStatus (){
        return this.$store.getters.fundraiserTechassessmentSubscriptionStatus
      }
   
       
    },
    watch: {
      /*
      fundraiserPayments(value){
        console.log('watch fundraiserPayments')
        var rtn = null
        var v = value
        console.log('watch fundraiserPayments value - ', this.$store.getters.fundraiserPayments, this.$store.getters.member,this.$store.getters.fundraiserPayments['techassessment'])
          if(this.$store.getters.member!==null && this.$store.getters.fundraiserPayments!==null && this.$store.getters.fundraiserPayments['techassessment']!==undefined){
            console.log('watch fundraiserPayments 1 ')
            var statuses = this.$store.getters.fundraiserPayments['techassessment'].filter(p=>{return p.ispayment===false && p.userid===this.$store.getters.member.userid})
            console.log('watch fundraiserPayments statuses ', statuses)
            if(statuses && statuses.length>0){
                var lastStatus = statuses[statuses.length - 1]
                rtn= new Object()
                if(lastStatus.transaction_type==="subscr_cancel"){
                    rtn.isactive = false                
                    rtn.statustype = "Subscription Cancelled"
                }else if(lastStatus.transaction_type==="subscr_eot"){
                    rtn.isactive = false
                    rtn.statustype = "Subscription Expired"
                }else if(lastStatus.transaction_type==="subscr_failed"){
                    rtn.isactive = false
                    rtn.statustype = "Subscription Payment Failed"
                }else if(lastStatus.transaction_type==="subscr_modify"){
                    rtn.isactive = true
                    rtn.statustype = "Subscription Active"
                }else if(lastStatus.transaction_type==="subscr_signup"){
                    rtn.isactive = true
                    rtn.statustype = "Subscription Active"
                }

                rtn.amount = lastStatus.paypaldetails.mc_amount3
                rtn.statusdate = lastStatus.paymentdate
                rtn.subscr_id = lastStatus.subscr_id
                
            }
          }else{
            console.log('watch fundraiserPayments value else')
          }
          this.techAssessmentMemberSubscriptionStatusCurrent = rtn
      },
      */
      messages(value) {
        if(value.length>0){
          this.showNotificationSnackbar = true
        }
      },      
      member (value) {

        if (value !== null && value !== undefined) {   
          LogRocket.identify(value.userid, {
            name: value.firstname + value.lastname,
            email: value.email,

            // Add your own custom user variables here, ie:
            chapter: value.chapter,
            org: value.org,
            line: value.lineid,
          });

           var tmpChapter = this.$store.getters.chapter
           var tmpOrg = this.$store.getters.org
           var tmpListPostTypes = this.$store.getters.listPostTypes
           var tmpListFundraiseTypes = this.$store.getters.listFundraiserTypes
           var tmpUserId = this.$store.getters.member.userid
           var tmpLineId = this.$store.getters.member.lineid
           if(tmpChapter !== null && tmpOrg !== null ){ 
             console.log('evaluating syncs')
              if(this.$store.getters.isSyncedPosts===false){
                console.log('syncing posts')
                this.$store.dispatch('initPostSynch',{org: tmpOrg, chapter: tmpChapter, listPostTypes: tmpListPostTypes, userid: tmpUserId})
              }
              if(this.$store.getters.isSyncedMessages===false){
                console.log('syncing messages')
                this.$store.dispatch('initMessageSynch',{org: tmpOrg, chapter: tmpChapter, lineid: tmpLineId, userid: tmpUserId})
              }
              console.log('this.$store.getters.isSyncedFundraiser',this.$store.getters.isSyncedFundraiser)
              if(this.$store.getters.isSyncedFundraiser===false){
                console.log('syncing fundraisers')
                value.listFundraiserTypes = tmpListFundraiseTypes
                this.$store.dispatch('initFundraiserSynch',value)
              } 
              console.log('syncing products')
              this.$store.dispatch('initProductsSynch',{org: tmpOrg}) 
              
           }

        }
      }

    },    

    methods: {
        text_truncate: function(str) {
            var length = 100;
            var ending = '...';

            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str
            }
        } ,      
      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/')
      },
      visitLinkedin () {
        var url = "https://www.linkedin.com/in/rodneycephas/"
        var win = window.open(url, '_blank');
        win.focus();
      },
      resetUI() {
        console.log('resetui')
          this.clearMessages();
          // [START get_token]
          // Get Instance ID token. Initially this makes a network call, once retrieved
          // subsequent calls to getToken will return from cache.
          console.log('resetui - getting token')
          
          this.$messaging.getToken().then(currentToken=> {
            this.currentToken = currentToken
            console.log('resetui - recieved token ' + this.currentToken)
            if (this.currentToken) {
              this.sendTokenToServer();
            } else {
              // Show permission request.
              console.log('No Instance ID token available. Request permission to generate one.');
              this.setTokenSentToServer(false);
            }
          }).catch(err=> {
            console.log('An error occurred while retrieving token. ', err);
           this.setTokenSentToServer(false);
          });
          // [END get_token]
        },
        sendTokenToServer() {
            if (!this.isTokenSentToServer()) {
              console.log('Sending token to server...');
              // TODO(developer): Send the current token to your server.

              this.$store.dispatch('updateNotificationToken', {member: this.member, token: this.currentToken}).then(errmsg => { //testing the gallery code                                    
                  //console.log('msg', errmsg)
                  if(errmsg && errmsg ==='failure'){
                      console.error('updateNotificationToken', errmsg) 
                  }else{
                      console.log('successfully sent token to server') 
                      
                  }
              })

              this.setTokenSentToServer(true);
            } else {
              console.log('Token already sent to server so won\'t send it again ' +
                  'unless it changes');
            }
        },
        isTokenSentToServer() {
            return window.localStorage.getItem('sentToServer') === '1';
        },
        setTokenSentToServer(sent) {
            window.localStorage.setItem('sentToServer', sent ? '1' : '0');
        },
        requestPermission() {
          return new Promise((resolve, reject) => {  
            console.log('Requesting permission...');
            // [START request_permission]
            try{
              var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
              if(iOS===false && Notification && Notification.permission){

                Notification.requestPermission().then(permissionResult=> { 

                  if (permissionResult === 'denied') {
                    console.log('Permission wasn\'t granted. Allow a retry.');
                    return;
                    reject('failed')
                  }
                  if (permissionResult === 'default') {
                    console.log('The permission request was dismissed.');
                    return;
                    reject('failed')
                  }

                  this.$messaging.requestPermission().then(()=> {
                    console.log('Notification permission granted.');
                    // TODO(developer): Retrieve an Instance ID token for use with FCM.
                    // [START_EXCLUDE]
                    // In many cases once an app has been granted notification permission, it
                    // should update its UI reflecting this.
                    this.resetUI();
                    resolve('success')
                    // [END_EXCLUDE]
                  }).catch(function(err) {
                    console.log('Unable to get permission to notify.', err);
                    reject('failed')
                  });
                  // [END request_permission]
                  

                });

              }else{
                console.log('messaging not enabled')
                reject('failed')
              }
            }catch(err){
              console.log('error ',err)
            }





          })
          },
        deleteToken() {
            // Delete Instance ID token.
            // [START delete_token]
            this.$messaging.getToken().then(currentToken=> {
              this.currentToken = currentToken
              this.$messaging.deleteToken(this.currentToken).then(()=> {
                console.log('Token deleted.');
                this.currentToken = null
                this.setTokenSentToServer(false);
                // [START_EXCLUDE]
                // Once token is deleted update UI.
                this.resetUI();
                // [END_EXCLUDE]
              }).catch(function(err) {
                console.log('Unable to delete token. ', err);
              });
              // [END delete_token]
            }).catch(function(err) {
              console.log('Error retrieving Instance ID token. ', err);
            });
          },
        appendMessage(payload) {
            this.messages.push(payload)
          },      
        clearMessages() {
            this.messages = []
          }      
        
    }  
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>


<style scoped>

#routerview {
  color: #000000;
}
.rounded-card{
  border-radius:50px;
}

#myhandle, a{
  text-decoration: none;
}
</style>